module.exports = __webpack_public_path__ + "static/media/sprite.09a84ca1.png";